module.exports = __webpack_public_path__ + "img/file.0016d282.svg";